// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"b941f984","300":"c7b147f7","952":"7a41ee71"}[chunkId] + ".chunk.js";
};